// extracted by mini-css-extract-plugin
export default {"container":"cM-z","topReviewHeading":"dM-z","criticalReview":"eM-z","favorableReview":"fM-z","vsSeparator":"gM-z"};